import React, { useState } from 'react'
import influencerImg from "../assets/images/influencer.png"
import ConversionCampaignsList from '../components/conversionCampaign/ConversionCampaignsList';
import ConversionCampaignCommissions from '../components/conversionCampaign/ConversionCampaignCommissions';


const ConversionCampaigns: React.FC = () => {

    const [searchQuery, setSearchQuery] = useState('');
    const [activeTab, setActiveTab] = useState('campaigns');

    return (
        <React.Fragment>
            <div className="bg-white">
                <div className="conversion-campaign-page-header">
                    <div className="search-and-filter">
                        <div className="campaign-search-container flex-grow-1">
                            <span className="campaign-search-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M11.5 2.75C6.66751 2.75 2.75 6.66751 2.75 11.5C2.75 16.3325 6.66751 20.25 11.5 20.25C16.3325 20.25 20.25 16.3325 20.25 11.5C20.25 6.66751 16.3325 2.75 11.5 2.75ZM1.25 11.5C1.25 5.83908 5.83908 1.25 11.5 1.25C17.1609 1.25 21.75 5.83908 21.75 11.5C21.75 14.0605 20.8111 16.4017 19.2589 18.1982L22.5303 21.4697C22.8232 21.7626 22.8232 22.2374 22.5303 22.5303C22.2374 22.8232 21.7626 22.8232 21.4697 22.5303L18.1982 19.2589C16.4017 20.8111 14.0605 21.75 11.5 21.75C5.83908 21.75 1.25 17.1609 1.25 11.5Z" fill="black" fillOpacity="0.5" />
                                </svg>
                            </span>
                            <input type="text" placeholder="Search By Brand" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} className="campaign-search-input" />
                        </div>
                        {/* <button className='new-btn new-btn-primary-outlined'>
                            <FilterIcon />
                            <span>Filter</span>
                        </button> */}
                    </div>
                    <div className="tagline-and-image">
                        <div className="tagline">
                            <h3 className='tagline-primary'>Share Influence & Earn</h3>
                            <span className='tagline-secondary'>Earn from Every Share.</span>
                        </div>
                        <img src={influencerImg} className='influencer-img' alt="influencer" />
                    </div>
                </div>
                <div className="conversion-campaign-tab-controls">
                    <span className={`conversion-campaign-tab-button ${activeTab === 'campaigns' ? 'active' : ''}`} onClick={() => setActiveTab('campaigns')}>All Brands</span>
                    <span className='tab-separator'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="1" height="38" viewBox="0 0 1 38" fill="none">
                            <path d="M0.5 1L0.499998 37" stroke="url(#paint0_linear_1185_3635)" strokeLinecap="round" />
                            <defs>
                                <linearGradient id="paint0_linear_1185_3635" x1="-0.5" y1="1" x2="-0.500002" y2="37" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#717171" stopOpacity="0" />
                                    <stop offset="0.5" stopColor="#717171" />
                                    <stop offset="1" stopColor="#717171" stopOpacity="0" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </span>
                    <span className={`conversion-campaign-tab-button ${activeTab === 'earnings' ? 'active' : ''}`} onClick={() => setActiveTab('earnings')}>My Earnings</span>
                </div>
            </div>
            <div data-bs-parent="#tab-group-3" className={`collapse ${activeTab === 'campaigns' ? 'show' : ''}`} id="tab-8">
                <ConversionCampaignsList searchQuery={searchQuery} />
            </div>

            <div data-bs-parent="#tab-group-3" className={`collapse ${activeTab === 'earnings' ? 'show' : ''}`} id="tab-8">
                <ConversionCampaignCommissions />
            </div>
        </React.Fragment>

    )
}

export default ConversionCampaigns